import type { ServiceState } from '@stores/services/services.reducer';

import { createSelector } from '@ngrx/store';
import { serviceKey } from '@stores/services/services.reducer';

const selectServiceState = (state: any): ServiceState => state[serviceKey];

export const serviceSuggestionSetId = createSelector(selectServiceState, (state) => {
  return state.service?.extras.suggestionSetId;
});

export const helpsNumber = createSelector(selectServiceState, (state) => {
  return state.service?.extras.aidsNumber;
});

export const trackers = createSelector(selectServiceState, (state) => {
  return state.service?.trackers;
});

export const hasFeatureFlagTrustpilot = createSelector(selectServiceState, (state) => {
  return state.service?.extras.featureFlags?.includes('trustpilot');
});

export const contactEmailKeys = (key: string) =>
  createSelector(selectServiceState, (state) => {
    const contactEmailKeys = state.service?.supportEmails;
    if (contactEmailKeys) return contactEmailKeys[key] ?? contactEmailKeys['default'];

    return 'MONEY';
  });
